// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Deliverable  {
    _originalTypeClassName = "Loom.BO.Deliverable";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Deliverable.translate = translateService;
}
this.Id = null;
this.Number = null;
this.Title = null;
this.Description = null;
this.DueMonth = null;
this.DueDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Number:any;
Title:any;
Description:any;
DueMonth:any;
DueDate:any;
DisseminationLevel:any;
WorkPackage:any;
DeliverableType:any;
Leader:any;
static setDisseminationLevel = ($this, value) => {
var oldValue = $this.DisseminationLevel;
$this.DisseminationLevel = value;
if (value != null) {
}
}
static setWorkPackage = ($this, value) => {
var oldValue = $this.WorkPackage;
$this.WorkPackage = value;
if (value != null) {
if (oldValue != null) {
Domain.WorkPackage.removeDeliverables(oldValue, $this);
}
Domain.WorkPackage.addDeliverables(value, $this);
}
}
static setDeliverableType = ($this, value) => {
var oldValue = $this.DeliverableType;
$this.DeliverableType = value;
if (value != null) {
}
}
static setLeader = ($this, value) => {
var oldValue = $this.Leader;
$this.Leader = value;
if (value != null) {
}
}

static GetDueDate($this: any): any{return Domain.Project.GetMonthDates($this?.WorkPackage?.Project, $this?.DueMonth)[1];
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}